import type { ReactNode } from "react";
import { BrandHero } from "../brand";
import { AppFooter } from "./AppFooter";

// Superficie istituzionale: accesso, recupero password, inviti, primo avvio.
// La testata porta i colori del logo; su desktop diventa il pannello di sinistra.
export function AuthShell({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-background">
      <BrandHero className="lg:w-[42%] lg:shrink-0 lg:min-h-screen lg:sticky lg:top-0 lg:px-12 lg:pt-12" />
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex-1 flex lg:items-center justify-center px-5 py-7 lg:py-12">
          <div className={wide ? "w-full max-w-2xl" : "w-full max-w-md"}>{children}</div>
        </div>
        <AppFooter variant="auth" />
      </div>
    </div>
  );
}
